import { AppViewModel } from "@/src/app.viewmodel";
import { ViteEnvironmentClient } from "@core/data/infrastructures/vite-environment-client";
import { ChatbotViewModel } from "@core/presentation/components/chatbot/chatbot.viewmodel";
import { LoadLayoutViewModel } from "@core/presentation/components/feedback/load-layout/load-layout.viewmodel";
import { SiderMenuViewModel } from "@core/presentation/components/layout/sider-menu/sider-menu.component.viewmodel";
import type { EnvironmentClient, PlatformStorage } from "@iot-platform/core";
import { coreTypes, DiModuleBuilder, LocalStorage } from "@iot-platform/core";
import { ContainerModule } from "inversify";

const webCoreModule = new DiModuleBuilder();

webCoreModule.registerSubModules(() => ({
    infrastructure: new ContainerModule(({ bind }) => {
        bind<EnvironmentClient>(coreTypes.infrastructure.EnvironmentClient)
            .to(ViteEnvironmentClient)
            .inSingletonScope();
        bind<PlatformStorage>(coreTypes.infrastructure.LocalStorage)
            .to(LocalStorage)
            .inSingletonScope();
    }),
    viewModels: new ContainerModule(({ bind }) => {
        bind(AppViewModel).toSelf().inSingletonScope();
        bind(ChatbotViewModel).toSelf();
        bind(LoadLayoutViewModel).toSelf().inSingletonScope();
        bind(SiderMenuViewModel).toSelf().inSingletonScope();
    }),
}));

webCoreModule.registerModule();

export { webCoreModule };
